import React from "react";
import { useTranslation } from "react-i18next";
import "./KnowledgeBaseGcpProjectGate.scss";

/** Inline notice matching Data Hero / Marketplace: browse is fine, create is not. */
export const KnowledgeBaseGcpCreateDisabledBanner: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="knowledge-base-gcp-gate__inline" role="alert">
            <i className="pi pi-exclamation-triangle" aria-hidden="true" />
            <div>
                <strong>{t("knowledgeBase.gcpRequired.createDisabled.title") as string}</strong>
                <p>{t("knowledgeBase.gcpRequired.createDisabled.message") as string}</p>
                <p className="knowledge-base-gcp-gate__inline-hint">
                    {t("knowledgeBase.gcpRequired.createDisabled.hint") as string}
                </p>
            </div>
        </div>
    );
};
